import generateRender from 'shared/utils/generateRender';
import { DefaultTermsModal } from './TermsModalComponents/DefaulTermsModal';

const TermsModal = generateRender({
  default: DefaultTermsModal,
});

export default TermsModal;

